import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { History } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import api from "@/lib/api";
import { formatDMY } from "@/lib/date";
import { STATUS_STYLES, DownloadPdfButton } from "@/components/quotation/QuotationBits";

const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;

export function VersionHistory({ quotation }) {
  const nav = useNavigate();
  const [versions, setVersions] = useState([]);
  useEffect(() => {
    api.get(`/quotations/${quotation.id}/versions`).then((r) => setVersions(r.data)).catch(() => setVersions([]));
  }, [quotation.id, quotation.status]);

  return (
    <div className="bg-white border border-slate-200 rounded-lg p-4" data-testid="version-history-panel">
      <div className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-2 flex items-center gap-1.5">
        <History className="w-3.5 h-3.5" /> Version history
      </div>
      <ul className="divide-y divide-slate-100">
        {versions.map((v) => {
          const current = v.id === quotation.id;
          return (
            <li key={v.id} className={`py-2 flex items-start gap-2 ${current ? "" : "cursor-pointer hover:bg-slate-50"} -mx-2 px-2 rounded`}
              onClick={() => !current && nav(`/quotations/${v.id}`)} data-testid={`version-row-${v.revision}`}>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-1.5 flex-wrap">
                  <span className={`font-mono text-xs ${current ? "font-semibold text-slate-900" : "text-indigo-700"}`}>{v.revision ? `Rev ${v.revision}` : "Original"}</span>
                  <Badge variant="outline" className={`${STATUS_STYLES[v.status] || ""} text-[10px]`} data-testid={`version-status-${v.revision}`}>{v.status}</Badge>
                  {current && <span className="text-[10px] text-slate-400">viewing</span>}
                </div>
                <div className="text-[11px] text-slate-500 mt-0.5">
                  {v.sent_at ? `Sent ${formatDMY(v.sent_at)}${v.sent_via ? ` · ${v.sent_via}` : ""}` : "Not sent"} · {inr(v.total_amount)}{v.quote_type === "rental" || v.quote_type === "rental_buy" ? " / month" : ""}
                </div>
              </div>
              <DownloadPdfButton quotation={v} compact testId={`version-download-${v.revision}`} />
            </li>
          );
        })}
      </ul>
    </div>
  );
}
